export class LatLng {
  constructor(public lat: number, public lng: number) { }
}

export class Address {
  constructor(
    public ref: number,
    public name: string,
    public building_name: string,
    public road_number: string,
    public road_name_1: string,
    public road_name_2: string,
    public town: string,
    public county: string,
    public postcode: string,
    public latLng: LatLng) {
  }

  get lng(): number {
    return this.latLng.lng;
  }

  get lat(): number {
    return this.latLng.lat;
  }

  searchString() {
    return `${this.building_name} ${this.road_name_1} ${this.road_name_2} ${this.town} ${this.county} ${this.postcode}`;
  }

}

export const addressData = [
  new Address(101,
    'Eastfields Shopping Centre',
    'Eastfield Shopping Centre',
    '',
    'Eastfield High Street',
    '',
    'BIRMINGHAM',
    '',
    'B5 4AH',
    new LatLng(52.486243, -1.890401)),
  new Address(102,
    'Tilda Industial Estate',
    'Tilda Industrial Estate',
    '',
    'Tilda Park',
    '',
    'LEEDS',
    '',
    'LS2 8NP',
    new LatLng(53.796305, -1.564126)),
  new Address(103,
    'Castlemead Offices',
    '',
    '15',
    'Castle Row',
    'Horticultural Place',
    'CHISWICK',
    '',
    'W4 4HY',
    new LatLng(51.490937, -0.264562)),
  new Address(104,
    'Lotus Road Development',
    'Lotus  Mansions',
    '',
    'Lotus Road',
    '',
    'CARDIFF',
    '',
    'CF5 1HL',
    new LatLng(51.483712, -3.212811)),
  new Address(201,
    'Riverside House',
    '',
    '150-200',
    'Riveride Drive',
    '',
    'SUNBURY ON THAMES',
    'Middlesex',
    'TW16 5QF',
    new LatLng(51.406553, -0.405245)),
  new Address(6001,
    'The Courthouse',
    'The Courthouse',
    '67',
    'Meophram Street',
    '',
    'LONDON',
    '',
    'SE1 8PR',
    new LatLng(51.495023, -0.128569)),
  new Address(6011,
    'Hendon House',
    'Hendon House',
    '56',
    'High Street',
    '',
    'LONDON',
    '',
    'W1 9WA',
    new LatLng(51.51369, -0.141487)),
  new Address(6021,
    'Vickers Avenue',
    'Vickers Avenue',
    '24',
    'Evelyn Street',
    '',
    'LONDON',
    '',
    'N3 6PP',
    new LatLng(51.488961, -0.040642)),
  new Address(6031,
    'Edgware Lane',
    'Edgware Lane',
    '',
    'Bluepond Lane',
    '',
    'WEMBLEY',
    'Middlesex',
    'TW5 3BB',
    new LatLng(51.550501, -0.304841)),
  new Address(6041,
    'Greenland Priory',
    'Greenland Priory',
    '',
    'Purley Way',
    '',
    'CROYDON',
    '',
    'CR7 5SW',
    new LatLng(51.362513, -0.118073)),
  new Address(6051,
    'Waterside Green',
    'Waterside Green',
    '',
    'Downton Palace',
    '',
    'HENDON',
    '',
    'NW9 5TT',
    new LatLng(51.586246, -0.220009)),
  new Address(7000,
    '2 Lavender Hill',
    '',
    '2',
    'Lavender Hill',
    'Battersea',
    'LONDON',
    '',
    'SW11 9GG',
    new LatLng(51.464929, -0.159154)),
  new Address(7010,
    'Southsides Shopping Centre',
    'Southsides',
    '4',
    'Wandsworth High Street',
    'Wandsworth',
    'LONDON',
    '',
    'SW18 4RF',
    new LatLng(51.455388, -0.194082)),
  new Address(7020,
    'Putney Exchange Shopping Centre',
    'Putney Exchange',
    '',
    'Putney High Street',
    'Putney',
    'LONDON',
    '',
    'SW15 8YY',
    new LatLng(51.463906, -0.216287)),
  new Address(7030,
    '24 Earlsfield Road',
    '',
    '24',
    'Earlsfield Road',
    'Earlsfield',
    'LONDON',
    '',
    'SW18 3DF',
    new LatLng(51.451712, -0.180324)),
  new Address(7040,
    '3 Balham High Street',
    '',
    '3',
    'Balham High Street',
    'Balham',
    'LONDON',
    '',
    'SW17',
    new LatLng(51.447797, -0.148454)),
  new Address(7050,
    '92 Roehampton Lane',
    '',
    '92',
    'Roehampton Lane',
    'Roehampton',
    'LONDON',
    '',
    'SW15 5PH',
    new LatLng(51.459327, -0.243097)),
  new Address(8000,
    'Castle House, Kingston-upon-Thames',
    'Castle House',
    '1',
    'Kingston Hill',
    'Kingston-upon-Thames',
    'SURREY',
    '',
    'KT2 7LB',
    new LatLng(51.427452, -0.273235)),
  new Address(8010,
    'Oak House, Leeds',
    'Oak House',
    '9',
    'Church Street',
    '',
    'LEEDS',
    '',
    'LE3 4AB',
    new LatLng(53.800769, -1.561292)),
  new Address(8020,
    'Pine House, Cambridge',
    'Pine House',
    '1',
    'Hills Road',
    '',
    'CAMBRIDGE',
    '',
    'CB1 9BP',
    new LatLng(52.198954, 0.128017)),
  new Address(8030,
    'Bridge Street Shopping Centre',
    'Bridge Street Shopping Centre',
    '2',
    'Kingston Hill',
    'Kingston-upon-Thames',
    'SURREY',
    '',
    'KT8 9AU',
    new LatLng(51.411646, -0.304777)),
  new Address(8040,
    'Parade House',
    'Parade House',
    '4',
    'The Mall',
    '',
    'LONDON',
    '',
    'SW1A 2ER',
    new LatLng(51.505778, -0.124287)),
  new Address(8050,
    'West Cross Shopping Centre',
    'West Cross Shopping Centre',
    '5',
    'Bailey Road',
    '',
    'SOUTHAMPTON',
    '',
    'SO5 7AS',
    new LatLng(50.9097, -1.404351)),
  new Address(8060,
    'South Park Science Park',
    'South Park Science Park',
    '50',
    'Manor Road',
    '',
    'HUNTINGDON',
    '',
    'PE28 8BT',
    new LatLng(52.318115, -0.11029)),
  new Address(8070,
    'Venture Park',
    'Venture Park',
    '95',
    'Bakers Street',
    '',
    'LONDON',
    '',
    'WC1B 3QQ',
    new LatLng(51.524145, -0.160991)),
  new Address(8110,
    '200-225 Osborne House',
    '',
    '200-225',
    'Store Street',
    '',
    'LONDON',
    '',
    'WC1E 7BT',
    new LatLng(51.519798, -0.131649)),
  new Address(8120,
    'Circle House',
    '',
    '200',
    'Stafford Circus',
    '',
    'STAFFORD',
    '',
    'STF123',
    new LatLng(52.806693, -2.12066)),
  new Address(8130,
    '100 City Road',
    '',
    '',
    '100',
    'City Road',
    'BRISTOL',
    '',
    'BS1',
    new LatLng(51.463796, -2.586024)),
  new Address(8140,
    '300-350 Helen Street ',
    '',
    '300-350',
    'Helen Street',
    '',
    'PORTSMOUTH',
    '',
    'PS1',
    new LatLng(50.819768, -1.087977)),
  new Address(8150,
    'Greenwich House',
    'Greenwich House',
    '',
    '100 Greewich Street',
    '',
    'EXETER',
    '',
    'EX1',
    new LatLng(50.728865, -3.478671)),
  new Address(8200,
    '30-50 Green Street',
    '',
    '30-50',
    'Green Street',
    '',
    'NORFOLK',
    '',
    '',
    new LatLng(52.613969, 0.886402)),
  new Address(8210,
    'Craig House',
    'Craig House',
    '',
    '15 Jury Street',
    '',
    'MANCHESTER',
    '',
    '',
    new LatLng(53.49393, -2.249474)),
  new Address(8220,
    '100-150 Rally Street',
    '',
    '100-150',
    'Rally Street',
    '',
    'BIRMINGHAM',
    '',
    '',
    new LatLng(52.486243, -1.890401)),
  new Address(8230,
    'Tottenham House',
    'Tottenham House',
    '50',
    'Tottenham Road',
    '',
    'TOTTENHAM',
    '',
    '',
    new LatLng(51.545243, -0.077786)),
  new Address(8240,
    'Palace House',
    'Palace House',
    '100',
    'Palace Road',
    '',
    'EXETER',
    '',
    '',
    new LatLng(50.721196, -3.52976)),
  new Address(8250,
    '60-80 Garrard Road',
    '60-80',
    'Garrard Road',
    '',
    '',
    'OXFORD',
    '',
    '',
    new LatLng(51.752021, -1.257726)),
  new Address(9000,
    'Enterprise House',
    'Enterprise House',
    '111',
    'Great Suffolk Street',
    '',
    'LONDON',
    '',
    'EC1 9PL',
    new LatLng(51.500678, -0.097762)),
  new Address(9010,
    'Newgate House',
    'Newgate House',
    '14',
    'Fleet Street',
    '',
    'LONDON',
    '',
    'N9 6PQ',
    new LatLng(51.51367, -0.111062)),
  new Address(9020,
    'Mannington House',
    'Mannington House',
    '19',
    'Greek Street',
    '',
    '',
    'London',
    'SE9 9SX',
    new LatLng(51.513991, -0.130072)),
  new Address(9030,
    'Amber Shopping Centre',
    'Amber House',
    '21',
    'New Globe Walk',
    '',
    'LONDON',
    '',
    'SE1 7PX',
    new LatLng(51.507987, -0.096571)),
  new Address(9040,
    'Phoenix House',
    'Phoenix House',
    '95',
    'York Street',
    '',
    'LONDON',
    '',
    'EC3 9BE',
    new LatLng(51.51128, -0.083567)),
  new Address(9050,
    'Burlington Shopping Centre',
    'Burlington Shopping Centre',
    '200',
    'Brewer Street',
    '',
    'LONDON',
    '',
    'WC2H 7PM',
    new LatLng(51.514284, -0.125525))
];
